import React, { useState } from 'react';
import styles from './LoginWitSSOPage.module.less';
import PiplLogo from '../../../../static/img/pipl_logo.svg';
import AppConfig from '../../Config/AppConfig';

const LoginWithSSOPage = () => {
  const [email, setEmail] = useState('');
  const buttonDisabled = email === '';
  const encodedEmail = encodeURIComponent(email);
  const otherUrlParameter = encodeURIComponent(window.location.search.replace('?', ''));
  const link = `/${AppConfig.ACCOUNTS_PREFIX}oidc/authenticate/?email=${encodedEmail}&${otherUrlParameter}`;

  return (
    <div className={styles.container}>
      <img src={PiplLogo} alt="" />
      <div className={styles.header}>Organization Login</div>
      <form>
        <label className={styles.label} htmlFor="#id_email">
          <input
            className={styles.emailInput}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="id_email"
            name="email"
            placeholder="Enter email"
            autoComplete="email"
            type="text"
          />
        </label>

        <a
          className={[styles.loginButton, buttonDisabled ? styles.disabled : null].join(' ')}
          href={link}
          type="submit"
        >
          Login
        </a>
      </form>
      <footer className={styles.footer}>
        <div className={styles.wrapper}>
          <ul className="list-inline centered" id="js-light-footer">
            <li>
              <a href="https://pipl.com/product-tos/">Terms</a>
            </li>
            <li>|</li>
            <li>
              <a href="https://pipl.com/privacy/">Privacy</a>
            </li>
            <li>|</li>
            <li>
              <a href="https://pipl.com/contact/">Contact</a>
            </li>
            <li>|</li>
            <li>
              <p className="copyright">&copy; 2006-{new Date().getFullYear()} pipl</p>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default LoginWithSSOPage;
